import { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../../firebase';
import Button from '../../components/ui/Button';
import { IconX } from '@tabler/icons-react';

export default function AddIntervalModal({ makeId, modelId, existingIntervals, onClose }) {
  const [name, setName] = useState('');
  const [hours, setHours] = useState('');
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const hoursNum = parseInt(hours);
  const duplicate = existingIntervals.some(i => i.triggerHours === hoursNum);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) { setError('Name is required.'); return; }
    if (!hoursNum || hoursNum < 1) { setError('Trigger hours must be a positive number.'); return; }
    if (duplicate) { setError('An interval at ' + hoursNum + ' hours already exists.'); return; }
    setError(''); setSaving(true);
    try {
      await addDoc(collection(db, 'makes', makeId, 'models', modelId, 'serviceIntervals'), {
        name: name.trim(),
        triggerHours: hoursNum,
        notes: notes.trim() || null,
        partsRequired: [],
        partsComplete: false,
        order: hoursNum,
        createdAt: serverTimestamp(),
        createdBy: auth.currentUser?.uid || null,
      });
      onClose();
    } catch (err) {
      console.error(err);
      setError('Failed to create interval: ' + err.message);
      setSaving(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }} onClick={onClose}>
      <div style={{ width: 440, background: 'var(--color-bg-primary)', borderRadius: 14, boxShadow: 'var(--shadow-lg)' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: '0.5px solid var(--color-border-light)' }}>
          <div style={{ fontSize: 15, fontWeight: 500 }}>New service interval</div>
          <div onClick={onClose} style={{ cursor: 'pointer', color: 'var(--color-text-tertiary)' }}><IconX size={18} stroke={1.5} /></div>
        </div>

        <form onSubmit={handleSubmit} style={{ padding: 24 }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 11, color: 'var(--color-text-secondary)', display: 'block', marginBottom: 4 }}>Interval name *</label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="e.g. 250 hour service" autoFocus required />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 11, color: 'var(--color-text-secondary)', display: 'block', marginBottom: 4 }}>Trigger hours *</label>
            <input type="number" min="1" value={hours} onChange={e => setHours(e.target.value)} placeholder="e.g. 250" required />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 11, color: 'var(--color-text-secondary)', display: 'block', marginBottom: 4 }}>Notes (optional)</label>
            <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Special instructions, oil type, etc." rows={3} style={{ resize: 'vertical', minHeight: 60 }} />
          </div>

          {error && <div style={{ padding: '8px 12px', background: 'var(--color-danger-light)', color: 'var(--color-danger)', borderRadius: 'var(--radius-md)', fontSize: 12, marginBottom: 16 }}>{error}</div>}

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <Button variant="secondary" onClick={onClose} type="button">Cancel</Button>
            <Button type="submit" loading={saving}>Create interval</Button>
          </div>
        </form>
      </div>
    </div>
  );
}
